module.exports = __webpack_public_path__ + "img/Theobroma_cacao.3f115c12.jpg";